import { doc, Timestamp, updateDoc } from 'firebase/firestore';
import type { EnhancedDeal, TimberProject } from '../types';
import { architectPortalGrantPlan } from './architectProjectAccess';
import { db } from './firebase';

/** Writes the architect's Auth uid onto the deal and each selected project. */
export async function grantArchitectPortalProjects(input: {
  uid: string;
  projectIds: string[];
  projects: Array<Pick<TimberProject, 'id' | 'dealId' | 'architectUids'>>;
  deals: Array<Pick<EnhancedDeal, 'id' | 'assignedArchitectUids'>>;
}): Promise<number> {
  const plan = architectPortalGrantPlan(input);
  const now = Timestamp.now();
  await Promise.all([
    ...plan.deals.map((deal) => updateDoc(doc(db, 'enhancedDeals', deal.id), {
      assignedArchitectUids: deal.assignedArchitectUids,
      updatedAt: now,
    })),
    ...plan.projects.map((project) => updateDoc(doc(db, 'timberProjects', project.id), {
      architectUids: project.architectUids,
    })),
  ]);
  return plan.projects.length;
}
